import type { TOC } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import FlowsSectionsFinalScreen from 'garaje/components/flows/sections/final-screen';

import type { LocationOverviewSignInFlowsShowFinalScreenRouteModel } from './route';

interface LocationOverviewSignInFlowsShowFinalScreenSignature {
  Args: {
    model: LocationOverviewSignInFlowsShowFinalScreenRouteModel;
  };
}

export default RouteTemplate(
  <template>
    <FlowsSectionsFinalScreen
      @translationLanguagesAvailable={{@model.flow.translationLanguagesAvailable}}
      @translationEnabledLocales={{@model.flow.translationEnabledLocales}}
      @defaultLocale="en"
      @flow={{@model.flow}}
      @summaryAttributeChangesets={{@model.summaryAttributeChangesets}}
      @summaryPage={{@model.summaryPage}}
      @isEditingCustomFinalMessage={{false}}
    />
  </template> satisfies TOC<LocationOverviewSignInFlowsShowFinalScreenSignature>,
);
